import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "destroy"]

  connect() {
    this.updatePositions()
    this.updateAddButton()
  }

  add(event) {
    event.preventDefault()
    
    const container = this.element
    const visibleItems = this.itemTargets.filter(item => item.style.display !== 'none')
    const lastItem = this.itemTargets[this.itemTargets.length - 1]
    
    if (visibleItems.length >= 4) {
      alert("최대 4개의 소셜 링크만 추가할 수 있습니다.")
      return
    }
    
    const newItem = lastItem.cloneNode(true)
    const newIndex = this.itemTargets.length
    
    // Update field names and IDs
    newItem.innerHTML = newItem.innerHTML.replace(/social_links_attributes\]\[\d+\]/g, `social_links_attributes][${newIndex}]`)
    newItem.innerHTML = newItem.innerHTML.replace(/social_links_attributes_\d+_/g, `social_links_attributes_${newIndex}_`)
    
    // Clear values and ensure item is visible
    const urlInput = newItem.querySelector('input[type="text"]')
    const platformSelect = newItem.querySelector('select')
    const positionInput = newItem.querySelector('input[name*="position"]')
    const destroyInput = newItem.querySelector('input[name*="_destroy"]')
    const extIdInput = newItem.querySelector('input[name*="ext_id"]')
    
    // Remove ext_id for new items (not persisted yet)
    if (extIdInput) extIdInput.remove()
    
    if (urlInput) urlInput.value = ''
    if (platformSelect) platformSelect.value = ''
    if (positionInput) positionInput.value = newIndex
    if (destroyInput) destroyInput.value = 'false'
    
    // Ensure the new item is visible
    newItem.style.display = ''
    
    lastItem.parentNode.insertBefore(newItem, lastItem.nextSibling)
    this.updatePositions()
    this.updateAddButton()
  }

  remove(event) {
    event.preventDefault()
    
    const item = event.target.closest('[data-social-links-target="item"]')
    const destroyInput = item.querySelector('[data-social-links-target="destroy"]')
    
    // If this is an existing record (has an ID), mark it for destruction
    const extIdInput = item.querySelector('input[name*="[ext_id]"]')

    if (extIdInput && extIdInput.value) {
      // Existing record - hide it and mark for destruction
      if (destroyInput) {
        destroyInput.value = 'true'
      }
      item.style.display = 'none'
    } else {
      // New record - just remove from DOM
      item.remove()
    }
    
    this.updatePositions()
    this.updateAddButton()
  }

  moveUp(event) {
    event.preventDefault()
    
    const item = event.target.closest('[data-social-links-target="item"]')
    const allItems = Array.from(this.itemTargets)
    const currentIndex = allItems.indexOf(item)
    
    if (currentIndex > 0) {
      const prevItem = allItems[currentIndex - 1]
      item.parentNode.insertBefore(item, prevItem)
      this.updatePositions()
    }
  }

  moveDown(event) {
    event.preventDefault()
    
    const item = event.target.closest('[data-social-links-target="item"]')
    const allItems = Array.from(this.itemTargets)
    const currentIndex = allItems.indexOf(item)
    
    if (currentIndex < allItems.length - 1 && currentIndex !== -1) {
      const nextItem = allItems[currentIndex + 1]
      item.parentNode.insertBefore(nextItem, item)
      this.updatePositions()
    }
  }

  updatePositions() {
    const items = this.itemTargets
    
    items.forEach((item, index) => {
      const positionInput = item.querySelector('input[name*="position"]')
      if (positionInput) {
        positionInput.value = index
      }
    })
  }

  updateAddButton() {
    const addButton = this.element.querySelector('[data-action="click->social-links#add"]')
    if (!addButton) return
    
    const visibleItems = this.itemTargets.filter(item => item.style.display !== 'none')
    
    if (visibleItems.length >= 4) {
      addButton.style.display = 'none'
    } else {
      addButton.style.display = ''
    }
  }
}